import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <div>
            <div
              data-testid="footer-brand"
              className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-white"
            >
              Wolf Land Investment LLC
            </div>
            <p className="mt-3 font-mono-accent text-[11px] tracking-[0.16em] uppercase text-[#737373]">
              Institutional CFD &amp; Wholesale Services
            </p>
          </div>

          <div className="flex gap-8">
            <a
              href="#services"
              data-testid="footer-link-services"
              className="nav-underline font-mono-accent text-[11px] tracking-[0.14em] uppercase text-[#A3A3A3] hover:text-[#00FFD1] transition-colors"
            >
              Services
            </a>
            <a
              href="#approach"
              data-testid="footer-link-approach"
              className="nav-underline font-mono-accent text-[11px] tracking-[0.14em] uppercase text-[#A3A3A3] hover:text-[#00FFD1] transition-colors"
            >
              Approach
            </a>
            <a
              href="#contact"
              data-testid="footer-link-contact"
              className="nav-underline font-mono-accent text-[11px] tracking-[0.14em] uppercase text-[#A3A3A3] hover:text-[#00FFD1] transition-colors"
            >
              Contact
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="legal-info">
            <p
              data-testid="footer-license"
              className="font-mono-accent text-[10px] md:text-[11px] tracking-[0.16em] uppercase text-[#525252]"
            >
              License No. 1482838 &nbsp;·&nbsp; Dubai Mainland Registered Company
            </p>
            <p
              data-testid="footer-activity"
              className="mt-2 font-mono-accent text-[10px] tracking-[0.14em] uppercase text-[#404040]"
            >
              Investment in Commercial Enterprises &amp; Management
            </p>
          </div>
          <p className="font-mono-accent text-[10px] tracking-[0.14em] uppercase text-[#404040]">
            © {new Date().getFullYear()} Wolf Land Investment LLC
          </p>
        </div>
      </div>
    </footer>
  );
};
